import { ShowPageLayout } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import ComplianceDocumentVersionFinalizeContent from './ComplianceDocumentVersionFinalizeContent';
import useComplianceDocumentVersionFinalizePageData from './useComplianceDocumentVersionFinalizePageData';

const ComplianceDocumentVersionFinalizePage = () => {
  const { search, getShowData, submitCreateVersion, getValidationSchema, afterSubmit } =
    useComplianceDocumentVersionFinalizePageData();

  return (
    <FormShowTemplate
      getDataFunc={getShowData}
      getValidationSchemaFunc={getValidationSchema}
      submitFormFunc={submitCreateVersion}
      afterSubmit={afterSubmit}
      initEditMode
    >
      <ShowPageLayout hasSeparateSections>
        <ComplianceDocumentVersionFinalizeContent search={search} />
      </ShowPageLayout>
    </FormShowTemplate>
  );
};

export default ComplianceDocumentVersionFinalizePage;
